import { AuthSingleton, api } from '@double.us/api';
import { API_URL } from '@double.us/core/config';

const TOKEN_STORAGE_KEY = 'auth_token';

/**
 * Authentication singleton instance.
 * Manages authentication tokens and their refreshing.
 */
export const token = new AuthSingleton(TOKEN_STORAGE_KEY);

/**
 * A callback function that is invoked when a token refresh fails.
 * Initially, it's an empty function.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
let on_refresh_failed = () => {};

/**
 * Registers a callback function to be invoked when a token refresh fails.
 * This allows external modules to react to authentication failures.
 * @param cb The callback function to register. It takes no arguments and returns void.
 */
export const register = (cb: () => void) => {
  on_refresh_failed = cb;
};

/**
 * Manually triggers the registered `on_refresh_failed` callback.
 * This can be useful for testing or simulating a refresh failure.
 */
export const trigger = () => {
  token.clear();
  on_refresh_failed();
};

/**
 * An initialized API client instance.
 * It uses the `token` singleton for authentication and includes the `on_refresh_failed`
 * callback for handling token refresh errors.
 */
export const client = api({
  url: API_URL,
  token,
  on_refresh_failed,
});
